import { RecommendationAnalytics } from '@/components/recommendations/RecommendationAnalytics';

export default function RecommendationAnalyticsPage() {
  return <RecommendationAnalytics />;
}